module.exports = __webpack_public_path__ + "static/media/vislit_autoethnography_banner.48084012.png";